import { Dialog } from 'primereact/dialog';
import { useEffect, useState } from 'react';
import {
  CatalogProject,
  CopyCatalogInfo
} from '../../../Helper/ApiHelper/LvEpNetworkHelper';
import BeeButton from '../../Atoms/BeeButton';
import AlphaEpCatalogPickerStep, {
  EpCatalogPickerRow,
  EpCatalogPickerSelection
} from './AlphaEpCatalogPickerStep';

type AlphaEpCatalogSelectDialogProps = {
  visible: boolean;
  /** EP catalog projects from {@link readAllEpCatalogsFromPlatform}. */
  catalogs: CopyCatalogInfo[];
  header?: string;
  readOnly?: boolean;
  onHide: () => void;
  onConfirm?: (selection: EpCatalogPickerSelection) => void;
};

export default function AlphaEpCatalogSelectDialog({
  visible,
  catalogs,
  header = 'EP-Katalog wählen',
  readOnly = false,
  onHide,
  onConfirm
}: AlphaEpCatalogSelectDialogProps) {
  const [selected, setSelected] = useState<EpCatalogPickerRow | null>(null);

  useEffect(() => {
    if (visible) {
      setSelected(null);
    }
  }, [visible]);

  function handleHide() {
    setSelected(null);
    onHide();
  }

  function handleConfirm() {
    if (!selected || !onConfirm) return;
    onConfirm({
      epCatalogProjectId: selected.id
    });
  }

  return (
    <Dialog
      header={header}
      visible={visible}
      modal={true}
      className={'bee-dialog-large bee-dialog-primary'}
      onHide={() => handleHide()}
    >
      <AlphaEpCatalogPickerStep
        readOnly={readOnly}
        catalogs={catalogs}
        selected={selected}
        onSelectionChange={(row) => setSelected(row)}
      />
      <div className={'flex justify-content-end gap-2 mt-3'}>
        {readOnly ? (
          <BeeButton
            type={'primary'}
            label={'Schließen'}
            onClick={() => handleHide()}
          />
        ) : (
          <>
            <BeeButton
              type={'secondary'}
              label={'Abbrechen'}
              onClick={() => handleHide()}
            />
            <BeeButton
              type={'primary'}
              label={'Übernehmen'}
              disabled={!selected}
              onClick={() => void handleConfirm()}
            />
          </>
        )}
      </div>
    </Dialog>
  );
}
